/* eslint-disable max-len */
import React from 'react';
import { useRouteData, useSiteData, Head } from 'react-static';
// template components
import Page from '@nmx/template/dist/componentLibrary/layout/Page';
import Theme from '@nmx/template/dist/componentLibrary/Theme';
// native components
import CommunitiesSection from './components/communitiesSection';
import CultureSection from './components/cultureSection';
import EnvironmentSection from './components/environmentSection';
import FinancialAccessSection from './components/financialAccessSection';
import GovernanceSection from './components/governanceSection';
import HeroSection from './components/heroSection';
import IntroSection from './components/introSection';
import Metadata from './components/metadata';
import PdfCalloutSection from '../components/pdfCalloutSection';
// images for prefetch
import highResDesktopImage from './components/heroSection/images/sustainability-impact-landing-hero-desktop.webp';
import highResMobileImage from './components/heroSection/images/sustainability-impact-landing-hero-mobile.webp';

export default () => {
  const { config, dynamicConfig } = useSiteData();
  const { pageProps } = useRouteData();

  return (
    <Page
      {...pageProps} // defined in route.js
      headComponent={Head}
      dynamicConfig={dynamicConfig}
      config={config}
      disableDisclaimerTopBorder
      breadcrumbsNavigationConfig={[
        {
          pageName: 'Home',
          linkUrl: '/',
          linkAriaLabel: 'Northwestern Mutual Home',
        },
        {
          pageName: 'Who we are',
          linkUrl: '/who-we-are/',
          linkAriaLabel: 'Northwestern Mutual Who We Are',
        },
        {
          pageName: 'Sustainability and Impact',
          linkUrl: '/who-we-are/sustainability-impact/',
          linkAriaLabel: 'Northwestern Mutual Sustainability Impact',
        },
      ]}>
      <Head>
        {/* prefetch expensive images */}
        <link rel='preload' href={highResMobileImage} as='image' media={`(max-width: ${Theme.breakpoints.values.medium}px)`} />
        <link rel='preload' href={highResDesktopImage} as='image' media={`(min-width: ${Theme.breakpoints.values.medium + 1}px)`} />
      </Head>

      <Metadata
        image={highResDesktopImage}
        pageDescription={pageProps.pageDescription}
        pageTitle={pageProps.pageTitle}
      />

      <HeroSection />

      <IntroSection />

      <FinancialAccessSection />

      <CommunitiesSection />

      <CultureSection />

      <EnvironmentSection />

      <GovernanceSection />

      <PdfCalloutSection />

    </Page>
  );
};
